<!--
This HTML file defines the structure and layout for the MMP File Upload component.
It includes:
- A header section.
- A file upload section with a button to trigger file selection.
- Instructions for users to upload transcripts for AI analysis.
-->

<div class="main-container" id="file-upload">
  <div class="header-container">
    <app-mmp-main-header></app-mmp-main-header>
  </div>
  <div class="upload-container">
    <div class="upload-section">
      <svg
        width="100"
        height="80"
        viewBox="0 0 100 80"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        >
        <path
          d="M61.4884 11.8188C62.3848 9.39375 65.8112 9.39374 66.7076 11.8188L69.6218 19.7026C71.4537 24.6584 75.3569 28.5657 80.3075 30.3994L88.1831 33.3167C90.6056 34.2141 90.6056 37.644 88.1831 38.5413L80.3075 41.4586C75.3569 43.2924 71.4537 47.1997 69.6218 52.1554L66.7076 60.0393C65.8112 62.4643 62.3848 62.4643 61.4884 60.0393L58.5742 52.1554C56.7423 47.1997 52.8391 43.2924 47.8885 41.4586L40.0128 38.5413C37.5903 37.644 37.5903 34.2141 40.0128 33.3167L47.8885 30.3994C52.8391 28.5657 56.7423 24.6584 58.5742 19.7026L61.4884 11.8188Z"
          fill="#E0E3E7"
          />
          <path
            d="M24.3313 39.212C24.8828 37.7199 26.991 37.7199 27.5425 39.212L29.3356 44.0628C30.4627 47.1119 32.8642 49.516 35.9102 50.6442L40.7559 52.4392C42.2464 52.9913 42.2464 55.1016 40.7559 55.6538L35.9102 57.4487C32.8642 58.577 30.4627 60.981 29.3356 64.0302L27.5425 68.881C26.991 70.373 24.8828 70.373 24.3313 68.881L22.5382 64.0302C21.4111 60.9811 19.0095 58.577 15.9636 57.4487L11.1179 55.6538C9.62737 55.1016 9.62737 52.9913 11.1179 52.4392L15.9636 50.6442C19.0095 49.516 21.4111 47.1119 22.5382 44.0628L24.3313 39.212Z"
            fill="#E0E3E7"
            />
            <path
              d="M19.6503 12.0353C19.9451 11.2377 21.0719 11.2377 21.3668 12.0353L22.3252 14.6281C22.9277 16.258 24.2114 17.543 25.8395 18.1461L28.4297 19.1056C29.2264 19.4007 29.2264 20.5287 28.4297 20.8238L25.8395 21.7833C24.2114 22.3864 22.9277 23.6714 22.3252 25.3013L21.3668 27.8941C21.0719 28.6917 19.9451 28.6917 19.6503 27.8941L18.6918 25.3013C18.0894 23.6714 16.8057 22.3864 15.1775 21.7833L12.5874 20.8238C11.7906 20.5287 11.7906 19.4007 12.5874 19.1056L15.1775 18.1461C16.8057 17.543 18.0894 16.258 18.6918 14.6281L19.6503 12.0353Z"
              fill="#E0E3E7"
              />
            </svg>
            <br />
            <p class="start-info">
              Start uploading your transcript so the AI can analyze them. After
              extraction, you’ll be able to review any flagged fields.
            </p>
            <button class="mmp-btn-primary" (click)="fileInput.click()">
              <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                >
                <g clip-path="url(#clip0_1701_5277)">
                  <path
                    d="M3 12.75V14.25C3 14.6478 3.15804 15.0294 3.43934 15.3107C3.72064 15.592 4.10218 15.75 4.5 15.75H13.5C13.8978 15.75 14.2794 15.592 14.5607 15.3107C14.842 15.0294 15 14.6478 15 14.25V12.75"
                    stroke="#00334C"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    />
                    <path
                      d="M5.25 6.75L9 3L12.75 6.75"
                      stroke="#00334C"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      />
                      <path
                        d="M9 3V12"
                        stroke="#00334C"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_1701_5277">
                          <rect width="18" height="18" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>

                    Upload Transcript
                  </button>
                  <input
                    type="file"
                    #fileInput
                    id="transcript-upload-input"
                    hidden
                    (change)="onFileSelected($event)"
                    multiple
                    [accept]="acceptedFormats"
                    aria-label="Upload transcript"
                    />
                  </div>
                </div>
                @if (isLoading) {
                  <div class="loader-overlay">
                    <div class="loader"></div>
                  </div>
                }
              </div>
